import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  Link,
  OutlinedInput,
  Paper,
  Tab,
  Tabs,
  Typography,
  Zoom,
  Divider,
  ButtonBase,
  SvgIcon,
} from "@mui/material";
import { ReactComponent as StarIcon } from "src/assets/icons/star.svg";
import { useAppSelector, useMobile } from "src/hooks";
import RestakeIcon from "src/assets/icons/restake.svg";
import RebaseTimer from "../../components/RebaseTimer/RebaseTimer";
import BannerImage from "src/assets/restake/banner.png";
import { t, Trans } from "@lingui/macro";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// 扩展dayjs插件
dayjs.extend(utc);
dayjs.extend(timezone);

export const CountDownBox = ({ time, text }: any) => {
  return (
    <Box
      sx={{
        width: { xs: "82px", sm: "150px" },
        height: { xs: "59px", sm: "108px" },
        border: { xs: "0.5px solid #fff", sm: "1px solid #fff" },
        background: "rgba(255,255,255,0.39)",
        backdropFilter: { xs: "blur(2.73px)", sm: "blur(5px)" },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: { xs: "6px", sm: "12px" },
      }}
    >
      <Typography
        sx={{
          color: "#eaecef",
          fontSize: { xs: "26px", sm: "48px" },
          fontWeight: "600",
        }}
      >
        {time}
      </Typography>
      <Typography
        sx={{
          color: "#fff",
          fontSize: { xs: "10px", sm: "18px" },
          fontWeight: "400",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};
const Restake = () => {
  const { isSmallScreen } = useMobile();

  // 倒计时状态
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // 目标时间：2025年6月17日上午10点整（北京时间）
  const targetDate = dayjs.tz("2025-06-26 14:00:00", "Asia/Shanghai");

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = dayjs();
      const diff = targetDate.diff(now);

      if (diff > 0) {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        // 倒计时结束
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    // 立即计算一次
    calculateTimeLeft();

    // 每秒更新一次
    const timer = setInterval(calculateTimeLeft, 1000);

    // 清理定时器
    return () => clearInterval(timer);
  }, [targetDate]);

  // 格式化数字，确保两位数显示
  const formatTime = (time: number) => {
    return time.toString().padStart(2, "0");
  };
  return (
    <Box
      display="flex"
      alignItems={"center"}
      flexDirection={"column"}
      sx={{
        position: "relative",
        mb: "100px",
      }}
    >
      <Box
        sx={{
          maxWidth: "1340px",
          width: { xs: "100%", sm: "97%" },
          pt: { sm: "87px", xs: "18px" },
          px: { xs: "15px", sm: "0" },
          position: "relative",
          zIndex: "1",
        }}
      >
        {/* restake top */}
        <Box
          sx={{
            mb: {
              xs: "20px",
              sm: "50px",
            },
          }}
          display="flex"
          alignItems={"cneter"}
          justifyContent={"space-between"}
          flexDirection={{
            sm: "row",
            xs: "column",
          }}
        >
          <Box
            display="flex"
            alignItems={"center"}
            sx={{
              mb: { xs: "15px", sm: "0" },
            }}
          >
            <Box
              sx={{
                mr: { sm: "20px", xs: "12px" },
              }}
            >
              <StarIcon
                style={{
                  width: isSmallScreen ? "37px" : "61px",
                  height: isSmallScreen ? "37px" : "61px",
                }}
              />
            </Box>
            <Box
              sx={{
                "&>img": {
                  width: { xs: "99px", sm: "163px" },
                },
              }}
              display="flex"
              flexDirection={"column"}
              // alignItems={"center"}
              justifyContent={"center"}
            >
              <img src={RestakeIcon} alt="restake" />

              <RebaseTimer />
            </Box>
          </Box>
        </Box>
        {/* restake bottom */}
        <Box
          sx={{
            mt: {
              xs: "40px",
              sm: "110px",
            },
          }}
          display="flex"
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
        >
          <Box
            sx={{
              mb: {
                sm: "38px",
                xs: "20px",
              },
              width: {
                sm: "306px",
                xs: "170px",
              },
              "&>img": {
                width: "100%",
              },
            }}
          >
            <img src={BannerImage} alt="banner" />
          </Box>
          {/* 倒计时部分 */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              mt: { xs: "40px", sm: "60px" },
              gap: { xs: "8px", sm: "10px" },
              flexWrap: "wrap",
            }}
          >
            <CountDownBox time={formatTime(timeLeft.days)} text={t`Day`} />
            <Box
              sx={{
                width: { xs: "24px", sm: "48px" },
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: { xs: "32px", sm: "48px" },
                  fontWeight: "600",
                }}
              >
                :
              </Typography>
            </Box>
            <CountDownBox time={formatTime(timeLeft.hours)} text={t`Hours`} />
            <Box
              sx={{
                width: { xs: "24px", sm: "48px" },
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: { xs: "32px", sm: "48px" },
                  fontWeight: "600",
                }}
              >
                :
              </Typography>
            </Box>
            <CountDownBox time={formatTime(timeLeft.minutes)} text={t`Minutes`} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Restake;
